import type { ReactNode } from 'react';

/** A two-line identity card (who or what, then a quiet meta line) with an optional action on the right. */
export const SourceCard = ({ title, meta, action }: { title: ReactNode; meta?: ReactNode; action?: ReactNode }) => (
  <div className='flex items-center gap-3 rounded-lg border border-gray-500 bg-white px-3 py-2.5'>
    <div className='flex min-w-0 flex-1 flex-col'>
      <span className='truncate text-[13px] leading-4.5 font-medium text-text-body'>{title}</span>
      {meta && <span className='truncate text-xs leading-4 text-gray-800'>{meta}</span>}
    </div>
    {action}
  </div>
);
